import { useState } from "react";
import { useClientContext } from "../../../hooks/ClientContext";
import { useCreateVulnerabilitySectionMutation, useFetchVulnerabilitySectionQuery, usePatchNotesMutation, usePatchVulnerabilitySectionMutation } from "../../../services/clientfactfind";
import { patchReplace } from "../../../helpers/patchDoc";

const useVulnerabilitySection = () => {
    const { id: masterAccountId } = useClientContext();
    const { data, isLoading, isError, error, refetch, isUninitialized } = useFetchVulnerabilitySectionQuery({ masterAccountId });
    const [create] = useCreateVulnerabilitySectionMutation();
    const [patch] = usePatchVulnerabilitySectionMutation();
    const [patchNotes] = usePatchNotesMutation();

    const createVulnerabilitySection = () => {
        return new Promise((resolve, reject) => {
            return create({ masterAccountId })
                .unwrap()
                .then(
                    r => resolve(r),
                    e => reject(e)
                );
        });
    };

    const patchVulnerabilitySection = (vulnerabilitySectionId, property, value) => {
        return new Promise((resolve, reject) => {
            const operations = [patchReplace(property, value)];
            return patch({ vulnerabilitySectionId, operations, masterAccountId })
                .unwrap()
                .then(
                    r => resolve(r),
                    e => reject(e)
                );
        });
    };

    const patchNotesSection = (notesId, newText) => {
        return new Promise((resolve, reject) => {
            return patchNotes({ notesId, newText })
                .unwrap()
                .then(
                    r => resolve(r),
                    e => reject(e)
                );
        });
    };

    const [isFetching, setIsFetching] = useState(false);

    const manualRefetch = () => {
        setIsFetching(true);
        return new Promise((resolve, reject) => {
            refetch().then(
                r => {
                    setIsFetching(false);
                    resolve(r);
                },
                e => reject(e)
            )
        })
    }

    return {
        data,
        isLoading: isLoading || isFetching || isUninitialized,
        isError,
        error,
        createVulnerabilitySection,
        refetchVulnerabilitySection: manualRefetch,
        patchNotesSection,
        patchVulnerabilitySection
    };
}

export default useVulnerabilitySection;